import { render, staticRenderFns } from "./FormCta.vue?vue&type=template&id=981e485a&scoped=true"
import script from "./FormCta.vue?vue&type=script&lang=js"
export * from "./FormCta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981e485a",
  null
  
)

export default component.exports